import {LineChartDataset} from './line-chart-dataset';

export class LineChartData {

  labels!: string[];
  datasets!: LineChartDataset[];

}
